import Vue from 'vue'
// import OSS from 'ali-oss'
// 定义全局方法
// let SSOURL = process.env.NODE_ENV == 'development' ? 'https://sso.xp-pen.com' : 'https://sso.xp-pen.com' //总站登录测试站
const SSOURL = process.env.NODE_ENV == 'development' ? 'https://sso.xp-pen.com' : 'https://account.xp-pen.com'

function getDomain() {
  return process.client ? window.location.origin : ''
}

function ssoRedirect(url) {
  if (process.client) {
    window.location.href = url
  }
}

/**
 * 登录/注册跳转（供插件、拦截器等无 Vue 实例处使用，需传入 Vuex store）
 */
export function jumpTerminusWithStore(store, type, id) {
  if (!store) return
  const siteConfig = store.state && store.state.siteConfig
  const useNewLogin = siteConfig && siteConfig.DialogPassportSwitch == '1'
  const domain = getDomain()

  switch (type) {
    case 1:
      if (useNewLogin) {
        store.commit('OPEN_AUTH_MODAL', { tab: 'login' })
      } else {
        ssoRedirect(`${SSOURL}/login/index?jumpUrl=${domain}/&lang=en`)
      }
      break
    case 2:
      if (useNewLogin) {
        store.commit('OPEN_AUTH_MODAL', { tab: 'register' })
      } else {
        ssoRedirect(`${SSOURL}/reg/index?jumpUrl=${domain}/&lang=en`)
      }
      break
    case 3:
      ssoRedirect(`${SSOURL}/login/logout?jumpUrl=${domain}/&lang=en`)
      break
    case 4:
      if (useNewLogin) {
        store.commit('OPEN_AUTH_MODAL', { tab: 'login' })
      } else {
        ssoRedirect(`${SSOURL}/login/index?jumpUrl=${domain}/tutorial/details?collection_type_id=${id}&collection_id=${id}/&lang=en`)
      }
      break
  }
}

function jumpTerminus(type, id) {
  jumpTerminusWithStore(this.$store, type, id)
}
let pathFiltering = (source) => {
  //判断  thumb_video �����否等于空
  //如果等于空的情况 判断 thumb_cover_original 是否为空 如果为空 取 thumb 如果不为空取 thumb_cover_original
  // 判断 video_cover_original 是否为空 如果为空 取 thumb_video 如果不为空取 video_cover_original
  const {
    thumb_video,
    thumb_cover_original,
    video_cover_original,
    thumb
  } = source;

  return thumb_video ?
    (video_cover_original || thumb_video) :
    (thumb_cover_original || thumb);
};

let avatarPathFilter = (source, type) => {
  //user_face_url原图    user_thumb_face_url 是小图   user_thumb_compress 是小于1000的大图
  //type1 是小图
  const {
    user_face_url,
    user_thumb_face_url,
    user_thumb_compress
  } = source
  return type == 1 ? (user_thumb_face_url || user_face_url) : (user_thumb_compress || user_face_url)

}

let uploadAction = () => {
  return process.env.NODE_ENV == 'production' ? 'https://apixfans.xp-pen.com/works/uploadfile' : 'https://dev.xfans.xp-pen.com/works/uploadfile'
}

// 添加OSS上传方法
let ossUpload = async function(file, ossConfig, options = {}) {
  // 确保在客户端环境且OSS已加载
  if (process.client && window.OSS) {
    const client = new window.OSS({
      region: ossConfig.bucket_url.split(".")[0],
      accessKeyId: ossConfig.accessKeyId,
      accessKeySecret: ossConfig.accessKeySecret,
      stsToken: ossConfig.securityToken,
      bucket: ossConfig.bucket,
    });

    const headers = {
      "Content-Type": file.type,
    };

    let ext = file.type.split("/")[file.type.split("/").length - 1];
    let folderName = `/web/${new Date().getFullYear()}/${
      new Date().getMonth() + 1 >= 1 && new Date().getMonth() + 1 <= 9
        ? "0" + String(new Date().getMonth() + 1)
        : new Date().getMonth() + 1
    }/${
      new Date().getDate() >= 1 && new Date().getDate() <= 9
        ? "0" + String(new Date().getDate())
        : new Date().getDate()
    }/${new Date().getTime()}`;

    let name = `${folderName}${Math.floor(Math.random() * 1000000000)}.${ext}`;

    const defaultOptions = {
      progress: (p) => {
        if(options.onProgress) {
          options.onProgress(parseInt(p * 100));
        }
      },
      parallel: 4,
      partSize: 1024 * 1024,
      headers,
      meta: { year: 2020, people: "test" },
      mime: "text/plain",
      timeout: 120000
    };

    try {
      const result = await client.multipartUpload(name, file, {
        ...defaultOptions,
        ...options
      });

      return result;
    } catch(err) {
      console.error('OSS upload failed:', err);
      throw err;
    }
  }
  return null;
}

// 挂载到 vue 原型中
// 注意：服务端内部钩子不能使用
Vue.prototype.$jumpTerminus = jumpTerminus;
Vue.prototype.$uploadAction = uploadAction;
Vue.prototype.$pathFiltering = pathFiltering
Vue.prototype.$avatarPathFilter = avatarPathFilter

// 只在客户端注册 ossUpload
if (process.client) {
  Vue.prototype.$ossUpload = ossUpload;
}

import * as filtersList from '@/assets/js/filters'
// 循环将每个过滤器注册到全局
Object.keys(filtersList).forEach(key => Vue.filter(key, filtersList[key]))
